import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'ngx-modal-simulacao',
  templateUrl: './modal-simulacao.component.html',
  styleUrls: ['./modal-simulacao.component.scss']
})
export class ModalSimulacaoComponent implements OnInit {

  @Input() valorVenda: string;
  @Input() tipoTaxa: string;
  @Input() bandeira: string;
  @Input() modalidade: string;

  @ViewChild("card", null)

  private card: ElementRef;
  public rowData: Array<any> = null;
  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    protected ref: NbDialogRef<ModalSimulacaoComponent>
    ) {


    }

  ngOnInit() {
    this.card.nativeElement.ownerDocument.activeElement.blur();

  }

  dismiss() {
    this.ref.close();
  }

}
